import CrudCustom from '../../../libs/custom/CrudCustom';


let SandingPPh21PerhitunganService = new CrudCustom('/sanding-pph21-perhitungans');
export default SandingPPh21PerhitunganService;
